import type { ComponentType } from 'react';
import { HomeIcon, CommunityIcon, CategoryIcon, ProfileIcon, AddIcon } from '@/assets/icons';

/**
 * ID элементов нижнего меню приложения
 */
export type BottomMenuItemId = 'home' | 'community' | 'wishlist' | 'profile' | 'add';

/**
 * Конфигурация элемента нижнего меню
 */
export interface BottomMenuItemConfig {
  id: BottomMenuItemId;
  /** Иконка — lucide или кастомная SVG-компонента */
  icon: ComponentType<{ className?: string }>;
  /** i18n ключ для label (например, 'navigation.home') */
  labelKey: string;
  isCenter?: boolean;
}

/**
 * Конфигурация элементов нижнего меню
 * SINGLE SOURCE OF TRUTH - единый источник истины для всех ID нижнего меню
 */
export const BOTTOM_MENU_CONFIG = {
  home: { 
    id: 'home', 
    icon: HomeIcon, 
    labelKey: 'navigation:navigation.home'
  },
  community: { 
    id: 'community', 
    icon: CommunityIcon, 
    labelKey: 'navigation:navigation.community'
  },
  add: { 
    id: 'add', 
    icon: AddIcon, 
    labelKey: 'navigation:navigation.add',
    isCenter: true 
  },
  wishlist: { 
    id: 'wishlist', 
    icon: CategoryIcon, 
    labelKey: 'common:wishlists'
  },
  profile: { 
    id: 'profile', 
    icon: ProfileIcon, 
    labelKey: 'navigation:navigation.profile'
  },
} as const satisfies Record<BottomMenuItemId, BottomMenuItemConfig>;

/**
 * Массив элементов нижнего меню в порядке отображения
 */
export const BOTTOM_MENU_ITEMS: BottomMenuItemConfig[] = [
  BOTTOM_MENU_CONFIG.home,
  BOTTOM_MENU_CONFIG.community,
  BOTTOM_MENU_CONFIG.add,
  BOTTOM_MENU_CONFIG.wishlist,
  BOTTOM_MENU_CONFIG.profile,
];

/**
 * Type guard для проверки валидности BottomMenuItemId
 */
export function isValidBottomMenuId(value: unknown): value is BottomMenuItemId {
  return typeof value === 'string' && value in BOTTOM_MENU_CONFIG;
}